import React from "react";
import { PowerPlantSelector } from "../components/core/PowerPlantSelector";
import { PowerPlantSummary } from "../components/core/PowerPlantSummary";

/**
 * Step 3: Install Power Plant
 * Allows users to select and configure the ship's power plant
 * according to Traveller rules and requirements
 *
 * @component
 * @example
 * ```tsx
 * <PowerPlantStep />
 * ```
 */
export const PowerPlantStep: React.FC = () => {
  return (
    <div className="pb-32">
      <PowerPlantSelector />
      <PowerPlantSummary />
    </div>
  );
};
